import { FirebaseOptions } from 'firebase/app'

// Public web-app config (safe to ship to browsers, not a secret). Kept
// side-effect free so Cypress can import it for REST auth calls without
// initializing the Firebase app.
const firebaseConfig: FirebaseOptions = {
  apiKey: 'AIzaSyAwVPuipbzssJbYeGHnXIyeHjlBVmx4CF8',
  authDomain: 'leen-61727.firebaseapp.com',
  projectId: 'leen-61727',
  appId: '1:544918921186:web:2afe14329d6954034563bb',
  messagingSenderId: '544918921186',
  measurementId: 'G-SC4ENJMFCH',
}

export default firebaseConfig
